import styled from '@emotion/styled';
import { Grid, Typography, css } from '@mui/material';
import { colors } from 'theme/colors';

interface IStyledFormLabel {
  disabled?: boolean;
}

export const StyledFormElementWrapper = styled.div<IStyledFormLabel>`
  display: flex;
  flex-direction: column;
  ${(props: IStyledFormLabel) =>
    props.disabled &&
    css`
      color: ${colors.gray400};
    `}
`;

export const StyledPageTitle = styled(Typography)`
  color: ${colors.black};
  margin-bottom: 20px;
  font-weight: 700;
`;

export const StyledPageSubTitle = styled(Typography)`
  color: ${colors.gray900};
`;

export const StyledAdvancedSearch = styled(Grid)`
  margin-top: 10px;
  margin-bottom: 5px;

  & .MuiGrid-item {
    padding-top: 0;
  }
`;

export const StyledForm = styled(Grid)`
  & .MuiGrid-item {
    padding-top: 0;
  }
`;
